// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"358":"f7d94049","967":"2e992a46"}[chunkId] + ".chunk.js";
};